import { Stack, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { ReactNode, isValidElement } from 'react';

interface IDataItem {
  label: string | ReactNode;
  content: string | ReactNode;
  width?: string;
}

export const DataItem = ({ content, label, width }: IDataItem) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack width={width} gap={isDesktop ? '14px' : '4px'}>
      {isValidElement(label) ? (
        label
      ) : (
        <Typography variant={'body6'}>{label}</Typography>
      )}
      {isValidElement(content) ? (
        content
      ) : (
        <Typography variant={'body4'}>{content}</Typography>
      )}
    </Stack>
  );
};
